// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"qp-z","imageAndVideoCount":"rp-z","imageAndVideoContainer":"sp-z","viewAllReviews":"tp-z"};